import {
  Box,
  Container,
  createTheme,
  FormControl,
  Link,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import Title from "../../components/Pages/Title";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SearchIcon from "@mui/icons-material/Search";
import AddchartIcon from "@mui/icons-material/Addchart";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import InfoIcon from "@mui/icons-material/Info";
import { useState } from "react";
import Pagination from "../../components/Pagination";
import { useRecoilState } from "recoil";
import { ThemeLight } from "../../state/ThemeLight";

const PendingTxs = () => {
  const loopData: number[] = [];

  const [limit, setLimit] = useState(25);
  const [total] = useState(0);
  const [page, setPage] = useState(0);

  const handleChange = (event: SelectChangeEvent) => {
    setLimit(parseInt(event.target.value));
  };

  return (
    <>
      <Title title="Pending Transactions" smallTitle="" />

      <Container className="container-xxl pt-5 pb-12">
        <Box className="card">
          <Box className="card-header d-flex flex-column flex-sm-row justify-content-between gap-3">
            <Box>
              <Link
                className="btn btn-sm btn-white text-black"
                href="/chart/pendingtx"
              >
                <AddchartIcon className="text-icon text-muted me-1" />
                Pending Transaction Pool
              </Link>
            </Box>
            <Box className="d-flex flex-wrap align-items-center gap-2">
              <Box
                id="ContentPlaceHolder1_searchdiv"
                className="dropdown order-md-2"
              >
                <button
                  className="btn btn-sm btn-secondary js-dropdowns-input-focus"
                  type="button"
                  id="dropdownSearchFilter"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <SearchIcon className="far fa-search text-icon" />
                </button>
                {/* <div
                  className="dropdown-menu dropdown-menu-sm-end"
                  aria-labelledby="dropdownSearchFilter"
                >
                  <div className="input-group">
                    <form
                      action="/txsPending"
                      method="get"
                      className="js-focus-state input-group input-group-sm w-100"
                    >
                      <input
                        className="js-input-focus form-control py-2"
                        id="q"
                        name="cn"
                        type="search"
                        value=""
                        placeholder="Filter by Address"
                      />
                      <button
                        type="submit"
                        className="btn btn-primary"
                        data-bs-toggle="tooltip"
                      >
                        Find
                      </button>
                    </form>
                  </div>
                </div> */}
                <Box
                  className="dropdown-menu dropdown-menu-sm-end"
                  aria-labelledby="dropdownSearchFilter"
                >
                  <Box className="input-group"></Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box>
                <span className="text-dark content-center gap-1">
                  A total of 0 pending txns found
                </span>
                <Box className="d-block text-muted small">
                  (Showing the last 10000 records)
                </Box>
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Pagination
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  total={total}
                />
              </Box>
            </Box>
          </Box>

          <TableContainer component={Paper} className="box-shadow-0">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" width={1}>
                    Txn Hash
                  </TableCell>
                  <TableCell align="left">
                    <Box className="d-flex align-items-center">
                      Method{" "}
                      <Tooltip
                        title={
                          "Function executed based on decoded input data. For unidentified functions, method ID is displayed instead."
                        }
                        placement="right"
                      >
                        <HelpOutlineIcon className="text-icon text-muted" />
                      </Tooltip>
                    </Box>
                  </TableCell>
                  <TableCell align="left">
                    <Link>None</Link>
                  </TableCell>
                  <TableCell align="left">Last Seen</TableCell>
                  <TableCell align="left">
                    <Link>Gas Limit</Link>
                  </TableCell>
                  <TableCell align="left">
                    <Link>
                      Gas Price{" "}
                      <Tooltip
                        title={
                          "For EIP 1559 tx, Max Fee Per Gas and Max Priority Fee Per Gas are displayed."
                        }
                        placement="top"
                      >
                        <HelpOutlineIcon className="text-icon text-muted" />
                      </Tooltip>
                    </Link>
                  </TableCell>
                  <TableCell align="left">From</TableCell>
                  <TableCell align="left">To</TableCell>
                  <TableCell align="left">Amount</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <div className="no-data">No Data Found</div>
                  <div
                    style={{
                      height: "100px",
                    }}
                  ></div>
                </TableRow>
                {loopData.map((data) => (
                  <TableRow>
                    <TableCell>
                      <Box className="hash-tag text-truncate">
                        <Link
                          href="/tx/0xcbddfe8514f46e34a7f2ed5ecc5853ee69f0e3e7bde1022341cdf68534aaeb95"
                          className="myFnExpandBox_searchVal"
                        >
                          0xcbddfe8514f46e34a7f2ed5ecc5853ee69f0e3e7bde1022341cdf68534aaeb95
                        </Link>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className="d-block badge bg-light border border-dark dark:border-white border-opacity-10 text-dark fw-normal text-truncate w-100 py-1.5">
                        <Tooltip describeChild title="Transfer" placement="top">
                          <span>Transfer</span>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>221</TableCell>
                    <TableCell>
                      <Tooltip title={"7 secs ago"} placement="top">
                        <Box rel="tooltip">
                          <InfoIcon className="text-icon text-muted mr-1" />7
                          secs ago
                        </Box>
                      </Tooltip>
                    </TableCell>
                    <TableCell>33268</TableCell>
                    <TableCell>12 Gwei</TableCell>
                    <TableCell>
                      <Box className="d-flex d-flex align-items-center gap-1">
                        <Link
                          href="/address/0x21a31ee1afc51d94c2efccaa2092ad1028285549"
                          className="hash-tag text-truncate border px-1 border-0"
                          data-bs-toggle="tooltip"
                          data-bs-trigger="hover"
                          data-bs-html="true"
                          data-bs-title="Public Tag: Binance 15<br/>(0x21a31ee1afc51d94c2efccaa2092ad1028285549)"
                        >
                          0x60009f...27B89d4A
                        </Link>

                        <Tooltip title="Copy Address" placement="top">
                          <Link className="js-clipboard link-secondary ">
                            <ContentCopyIcon
                              className="text-icon"
                              onClick={() => navigator.clipboard.writeText("")}
                            />
                          </Link>
                        </Tooltip>
                        <Tooltip
                          title="Apply filter buy address"
                          placement="top"
                        >
                          <Link
                            className="js-clipboard link-secondary "
                            aria-label="Copy Address"
                          >
                            <FilterAltOutlinedIcon className="text-icon" />
                          </Link>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className="d-flex d-flex align-items-center gap-1">
                        <Box className="d-flex align-items-center gap-1 border px-1 border-0">
                          <Tooltip
                            title="Public Tag: Fee Recipient: 0xe68...127 (0xe688b84b23f322a994a53dbf8e15fa82cdb71127)"
                            placement="top"
                          >
                            <Link
                              href="/address/0x1dde41f92d3f7a46ce6f6de24ab3a94a45a3d708"
                              className=""
                              data-bs-toggle="tooltip"
                              data-bs-trigger="hover"
                              data-bs-html="true"
                              data-bs-title="0x1dde41f92d3f7a46ce6f6de24ab3a94a45a3d708"
                            >
                              0x1dDe41...45A3d708
                            </Link>
                          </Tooltip>
                          <Tooltip title="Copy Address" placement="top">
                            <Link className="js-clipboard link-secondary ">
                              <ContentCopyIcon
                                className="text-icon"
                                onClick={() =>
                                  navigator.clipboard.writeText("")
                                }
                              />
                            </Link>
                          </Tooltip>
                          <Tooltip
                            title="Apply filter buy address"
                            placement="top"
                          >
                            <Link
                              className="js-clipboard link-secondary "
                              aria-label="Copy Address"
                            >
                              <FilterAltOutlinedIcon className="text-icon" />
                            </Link>
                          </Tooltip>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Tooltip title="0.027354773076765 UPC" placement="top">
                        <Box>0.027354773 UPC</Box>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box
                id="ContentPlaceHolder1_pageRecords"
                className="d-flex align-items-center gap-2 text-nowrap text-muted"
              >
                Show:
                <FormControl sx={{ m: 1, minWidth: 70 }}>
                  <Select
                    value={limit.toString()}
                    onChange={handleChange}
                    displayEmpty
                    size="small"
                  >
                    <MenuItem
                      value={10}
                      sx={{
                        fontSize: "12px;",
                      }}
                    >
                      10
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={25}
                    >
                      25
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={50}
                    >
                      50
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={100}
                    >
                      100
                    </MenuItem>
                  </Select>
                </FormControl>
                Records
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Pagination
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  total={total}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default PendingTxs;
